/**
 * Common breakpoints used to toggle UI features/layout
 * Should match up with breakpoints used in Sass mixin
 * (see: themes/made-curious/src/styles/1-mixins/_breakpoints.scss)
 */
export const BREAKPOINTS = {
  TABLET_PORTRAIT_MIN: '600px',
  IPAD_PORTRAIT_MIN: '768px',
  TABLET_LANDSCAPE_MIN: '900px',
  SMALL_DESKTOP_LANDSCAPE_MIN: '1260px',
  MEDIUM_DESKTOP_LANDSCAPE_MIN: '1440px',
  BIG_DESKTOP_LANDSCAPE_MIN: '1920px',
}

export const NAVIGATION_BREAKPOINT = BREAKPOINTS.TABLET_LANDSCAPE_MIN
export const PEOPLE_PAGE_BREAKPOINT = BREAKPOINTS.IPAD_PORTRAIT_MIN
